// extracted by mini-css-extract-plugin
export default {"Header":"ZoneDetails_Header__uVfzT","HeaderRowValue":"ZoneDetails_HeaderRowValue__zLe2k","Quantity":"ZoneDetails_Quantity__mkYnk"};